import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DueDatesComponent } from './due-dates/due-dates.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { PlanDetailComponent } from './plan-detail/plan-detail.component';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { PlanEmailDetectorPipe } from './pipes/plan-email-detector.pipe';

const declarations = [
  DueDatesComponent,
  PlanDetailComponent,
  PlanEmailDetectorPipe,
];

@NgModule({
  declarations,
  imports: [CommonModule, IonicModule, FormsModule, GeneralesComponentsModule],
  exports: declarations,
})
export class SubscriptionComponentsModule {}
